import { Gem, CircleDollarSign, User, Package, ListPlus } from "lucide-react";

const set = (s) => new Set(s.split(" "));
const GROUPS = {
  customer: { title: "Customer & certificate", icon: User, color: "#38BDF8", tokens: set("CERT CUSTOMER MOBILE PHONE NAME ISSUE DATE ADDRESS EMAIL") },
  metal: { title: "Metal details", icon: CircleDollarSign, color: "#F59E0B", tokens: set("METAL PURITY KARAT GOLD SILVER PLATINUM GROSS NET HALLMARK HUID WT WEIGHT") },
  diamond: { title: "Diamond details", icon: Gem, color: "#A78BFA", tokens: set("DIAMOND DIA CLARITY COLOR COLOUR CARAT CT CUT SHAPE STONE GEM POLISH SYMMETRY FLUORESCENCE") },
  item: { title: "Item & photo", icon: Package, color: "#34D399", tokens: set("ITEM PRODUCT PHOTO IMAGE DESIGN PIECE TYPE") },
  other: { title: "Other details", icon: ListPlus, color: "#94A3B8", tokens: set("") },
};
const has = (g, toks) => toks.some((t) => GROUPS[g].tokens.has(t));

const groupOf = (f) => {
  const toks = f.key.toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
  if (f.type === "image") return "item";
  if (has("diamond", toks)) return "diamond";
  if (GROUPS.item.tokens.has(toks[0])) return "item";
  return ["metal", "customer", "item"].find((g) => has(g, toks)) || "other";
};

export function groupFields(fields) {
  return Object.entries(GROUPS)
    .map(([id, g]) => ({ id, ...g, fields: fields.filter((f) => groupOf(f) === id) }))
    .filter((g) => g.fields.length);
}
